import formatDate from '../../../Utils/formatDate';

const handleColor = (status, tema) => {
  let color = {};

  switch (status) {
    case 'Em aberto':
    case 'Em andamento':
    case 'Em atendimento':
      color = { bg: tema?.primaryColorFade, colorText: tema?.primaryColor };
      break;

    case 'Concluído':
      color = {
        bg: 'rgba(132, 132, 132, 0.4)',
        colorText: 'rgba(132, 132, 132)',
      };
      break;
    default:
      color = { bg: tema?.accentFade, colorText: tema?.accent };
      break;
  }

  return color;
};

const handleRequestDateTime = (solicitacao) => {
  let fusoHorario = new Date().getTimezoneOffset();
  let requestTime = new Date(solicitacao.dataAgendamento);
  requestTime.setMinutes(fusoHorario);

  if (
    solicitacao.tipo === 'Assistência Técnica' &&
    requestTime.getHours() < 12
  ) {
    return `${formatDate(solicitacao.dataAgendamento)} 
      - Manhã`;
  } else if (
    solicitacao.tipo === 'Assistência Técnica' &&
    requestTime.getHours() >= 12
  ) {
    return `${formatDate(solicitacao.dataAgendamento)} 
      - Tarde`;
  } else {
    return `${formatDate(solicitacao.dataAgendamento)} 
      - ${requestTime.getHours()}:00`;
  }
};

const handleButtonName = ({ status }) => {
  let buttonName = '';
  switch (status) {
    case 'Cancelado':
      buttonName = 'Fechado';
      break;

    case 'Em atendimento':
      buttonName = 'Em andamento';
      break;

    default:
      buttonName = status;
      break;
  }

  return buttonName;
};

const handleDateOtherTypesSolicitation = (
  dataAgendamento,
  dataAgendamentoFinal
) => {
  let stringDateFormatted = `${formatDate(dataAgendamento)} 
  - ${dataAgendamento.split('T')[1].substring(0, 5)}`;

  if (dataAgendamentoFinal) {
    stringDateFormatted += ` às 
    ${dataAgendamentoFinal?.split('T')[1]?.substring(0, 5)}`;
  }

  return stringDateFormatted;
};

export {
  handleColor,
  handleRequestDateTime,
  handleButtonName,
  handleDateOtherTypesSolicitation,
};
